import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zfwjzfkx9f: FaireBrandEntity = {
  token: "b_zfwjzfkx9f",
  type: "brand",
  name: "Itsy Bitsy Boutique",
  avatarUrl:
    "https://cdn.faire.com/fastly/51b5b9c0ff6fbf6b6e60d219e8f5840230f69042dce80c808bb45c9de52ea912.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/51506801d2bd8756783bcac32476619ec4caedd27af4314ebfac3f742bd4e932.png",
  logoUrl:
    "https://cdn.faire.com/fastly/51b5b9c0ff6fbf6b6e60d219e8f5840230f69042dce80c808bb45c9de52ea912.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/51506801d2bd8756783bcac32476619ec4caedd27af4314ebfac3f742bd4e932.png",
  location: "Duncan, BC, CAN",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 2,
  isTopShop: true,
  isInsider: false,
  description:
    "Mama-owned. Softness you can feel good about.\n\nAt Itsy Bitsy Boutique, we believe baby clothes should be as gentle on the planet as they are on your little one’s skin. Born in the Cowichan Valley on Vancouver Island, our boutique was founded by a Canadian mom of two who wanted better: better fabrics, better quality, and better values.\n\nOur journey started with a single bamboo onesie, ultra-soft, breathable, and made to move with growing babes. We saw how much parents loved the fit, the feel, and the function, and from there, Itsy Bitsy grew into a line of thoughtfully designed sleep and playwear for babies and toddlers.\n\nWe design every piece with intention:\n• Viscose bamboo that’s gentle on sensitive skin\n• Gender-neutral styles with timeless charm\n• Quality craftsmanship that stands up to real life (and real messes)\n\nItsy Bitsy isn’t just a name, it’s a nod to the tiny people who inspire us every day. We’re proud to offer pieces that make parents’ lives easier and little ones’ lives cozier.\n\nWe’re here to help you stock your shelves with products your customers will fall in love with, from first snuggle to final hand-me-down.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:52:08.679Z",
    importedBy: "entity-db-cli",
  },
};
